<template>
  <div class="first-step">
    <div class="first-step__vehicle">
      <div class="steps__title"><span>2.1</span> Selecciona tu vehículo</div>
      <div class="first-step__vehicle__grid">
        <div
          v-for="vehicle in vehicles"
          :key="vehicle.id"
          class="vehicle__item"
        >
          <input
            type="radio"
            :id="`vehicle${vehicle.id}`"
            v-model="order.vehicle_id"
            :value="vehicle.id"
          />
          <label class="vehicle__label" :for="`vehicle${vehicle.id}`">
            <img
              :src="url_assets + vehicle.brand_icon"
              :alt="vehicle.brand_id"
            />
            <span class="vehicle__information">
              <span>
                <p>Modelo:</p>
                <p>{{ vehicle.model_name }} {{ vehicle.version_name }}</p>
              </span>
              <span>
                <p>Placa:</p>
                <p>{{ vehicle.plate }}</p>
              </span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="first-step__service">
      <div class="steps__title">
        <span>2.2</span> Selecciona el tipo de servicio
      </div>
      <div class="first-step__service__grid">
        <div v-if="isMaintenance" class="input-box input-box--checkbox">
          <input
            type="checkbox"
            name="operation_flag"
            id="operation_flag"
            v-model="order.operation_flag"
            :disabled="order.request_response"
          />
          <label
            for="operation_flag"
            :class="{ disabled: order.request_response }"
          >
            <img
              :src="`${url_assets}frontend/img/mecanica-general.svg`"
              alt="Mantenimiento Periódico"
            />
            <span>Mantenimiento Periódico</span>
          </label>
        </div>
        <div v-if="isGLP" class="input-box input-box--checkbox">
          <!-- <input
            type="checkbox"
            name="conversion_flag"
            id="glp_conversion"
            v-model="order.glp_conversion"
            @input="
              ($event) =>
                putMessageInRequest(
                  $event.target.checked,
                  'Solicito me contacten previamente a mi cita para conocer precios y opciones de equipos de GLP para mi vehículo.'
                )
            "
          /> -->
          <input
            type="checkbox"
            name="conversion_flag"
            id="glp_conversion"
            v-model="order.glp_conversion"
          />
          <label for="glp_conversion">
            <img
              :src="`${url_assets}frontend/img/glp.svg`"
              alt="Mantenimiento o Conversión a GLP"
            />
            <span>Mantenimiento o Conversión a GLP</span>
          </label>
        </div>
        <div v-if="isGNV" class="input-box input-box--checkbox">
          <!-- <input
            type="checkbox"
            name="conversion_flag"
            id="gnv_conversion"
            v-model="order.gnv_conversion"
            @input="
              ($event) =>
                putMessageInRequest(
                  $event.target.checked,
                  'Solicito me contacten previamente a mi cita para conocer precios y opciones de equipos de GNV para mi vehículo.'
                )
            "
          /> -->
          <input
            type="checkbox"
            name="conversion_flag"
            id="gnv_conversion"
            v-model="order.gnv_conversion"
          />
          <label for="gnv_conversion">
            <img
              :src="`${url_assets}frontend/img/gnv.svg`"
              alt="Mantenimiento o Conversión a GNV"
            />
            <span>Mantenimiento o Conversión a GNV</span>
          </label>
        </div>
        <div v-if="isCYP" class="input-box input-box--checkbox">
          <input
            type="checkbox"
            name="conversion_flag"
            id="body_work"
            v-model="order.body_work"
            @input="
              ($event) =>
                putMessageInRequest(
                  $event.target.checked,
                  'Solicito me contacten previamente a mi cita para conocer opciones de reparación de carrocería y pintura para mi vehículo.'
                )
            "
          />
          <label for="body_work"
            ><img
              :src="`${url_assets}frontend/img/planchado-pintura.svg`"
              alt="Carrocería y Pintura"
            />
            <span>Carrocería y Pintura</span>
          </label>
        </div>
        <div class="input-box input-box--checkbox">
          <input
            type="checkbox"
            name="other_requirements"
            id="other_requirements"
            v-model="order.other_requirements_flag"
          />
          <label for="other_requirements">
            <img
              :src="`${url_assets}frontend/img/elipsis.svg`"
              alt="Requerimientos adicionales"
            />
            <span>Requerimientos adicionales</span>
          </label>
        </div>
      </div>

      <!-- Operations filters -->
      <div v-if="order.operation_flag" class="operations-filters">
        <div class="operations-filters__item">
          <div class="input-box input-box--select">
            <label for="part_type">Repuestos:</label>
            <select
              name="part_type"
              id="part_type"
              v-model="operationFilter.part_type"
            >
              <option value="">Selecciona</option>
              <option
                v-for="partType in partTypes"
                :key="partType.part_type"
                :value="partType.part_type"
              >
                {{ partType.part_type }}
              </option>
            </select>
          </div>
        </div>
        <div class="operations-filters__item">
          <div class="input-box input-box--select">
            <label for="plan_type">Periodicidad:</label>
            <select
              name="plan_type"
              id="plan_type"
              v-model="operationFilter.plan_type"
            >
              <option value="">Selecciona</option>
              <option
                v-for="planType in planTypes"
                :key="planType.plan_type"
                :value="planType.plan_type"
              >
                Cada {{ planType.plan_type * 0.001 }} mil
              </option>
            </select>
          </div>
        </div>
        <div class="operations-filters__item">
          <div class="input-box input-box--select">
            <label for="service_type">
              Servicio:
              <a
                href="#"
                class="input-box__info"
                @click.prevent="openOperationsModal(order.operation_id)"
                data-tooltip="tooltip"
                data-bs-placement="right"
                title="¿Qué incluye?"
              >
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M256,0C114.51,0,0,114.5,0,256c0,141.49,114.5,256,256,256c141.49,0,256-114.5,256-256C512,114.51,397.5,0,256,0z M282.29,357.62c0,8.09-11.79,16.17-26.28,16.17c-15.16,0-25.95-8.09-25.95-16.17V229.23c0-9.43,10.78-15.84,25.95-15.84 c14.49,0,26.28,6.4,26.28,15.84V357.62z M256.01,182.4c-15.5,0-27.63-11.46-27.63-24.26c0-12.8,12.13-23.93,27.63-23.93 c15.16,0,27.3,11.12,27.3,23.93C283.3,170.94,271.17,182.4,256.01,182.4z"
                    />
                  </g>
                </svg>
              </a>
            </label>
            <select
              name="service_type"
              id="service_type"
              v-model="operationFilter.service_type"
            >
              <option value="">Selecciona</option>
              <option
                v-for="serviceType in serviceTypes"
                :key="serviceType.service_type"
                :value="serviceType.service_type"
              >
                {{ serviceType.service_type_format }}
                Km
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- GLP & GNV filters -->
      <div
        v-if="order.glp_conversion || order.gnv_conversion"
        class="operations-filters"
      >
        <div class="operations-filters__item">
          <div class="input-box input-box--select">
            <label for="part_type">Tipo de Servicio:</label>
            <select
              name="part_type"
              id="part_type"
              v-model="gasOperationsFilter.part_type"
            >
              <option value="">Selecciona</option>
              <option
                v-for="partType in partTypes"
                :key="partType.part_type"
                :value="partType.part_type"
              >
                {{ partType.part_type }}
              </option>
            </select>
          </div>
        </div>
        <div class="operations-filters__item">
          <div class="input-box input-box--select">
            <label for="fuel_type">Combustible:</label>
            <select
              name="fuel_type"
              id="fuel_type"
              v-model="gasOperationsFilter.fuel_type"
            >
              <option value="">Selecciona</option>
              <option v-if="order.glp_conversion && !isDiesel" value="GLP">
                GLP
              </option>
              <option v-if="order.gnv_conversion && !isDiesel" value="GNV">
                GNV
              </option>
              <option
                v-if="
                  isDiesel && (order.gnv_conversion || order.glp_conversion)
                "
                value="Dual Fuel"
              >
                Dual Fuel
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="
            gasOperationsFilter.part_type !== 'Conversión' &&
            gasOperationsFilter.fuel_type !== 'Dual Fuel'
          "
          class="operations-filters__item"
        >
          <div class="input-box input-box--select">
            <label for="gas_generation">Generación:</label>
            <select
              name="gas_generation"
              id="gas_generation"
              v-model="gasOperationsFilter.gas_generation"
            >
              <option value="">Selecciona</option>
              <option
                v-for="generation in generations"
                :key="generation.gas_generation"
                :value="generation.gas_generation"
              >
                {{ generation.gas_generation }}
              </option>
            </select>
          </div>
        </div>
        <div class="operations-filters__item">
          <div class="input-box input-box--select">
            <label for="service_type">
              Servicio:
              <a
                href="#"
                class="input-box__info"
                @click.prevent="openOperationsModal(order.operation_id)"
                data-tooltip="tooltip"
                data-bs-placement="right"
                title="¿Qué incluye?"
              >
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M256,0C114.51,0,0,114.5,0,256c0,141.49,114.5,256,256,256c141.49,0,256-114.5,256-256C512,114.51,397.5,0,256,0z M282.29,357.62c0,8.09-11.79,16.17-26.28,16.17c-15.16,0-25.95-8.09-25.95-16.17V229.23c0-9.43,10.78-15.84,25.95-15.84 c14.49,0,26.28,6.4,26.28,15.84V357.62z M256.01,182.4c-15.5,0-27.63-11.46-27.63-24.26c0-12.8,12.13-23.93,27.63-23.93 c15.16,0,27.3,11.12,27.3,23.93C283.3,170.94,271.17,182.4,256.01,182.4z"
                    />
                  </g>
                </svg>
              </a>
            </label>
            <select
              name="service_type"
              id="service_type"
              v-model="gasOperationsFilter.service_type"
            >
              <option value="">Selecciona</option>
              <option
                v-for="serviceType in serviceTypes"
                :key="serviceType.service_type"
                :value="
                  gasOperationsFilter.part_type === 'Conversión'
                    ? serviceType.name
                    : serviceType.service_type
                "
              >
                {{
                  gasOperationsFilter.part_type === 'Mantenimiento'
                    ? serviceType.service_type_format
                    : serviceType.name
                }}
                Km
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- <div v-if="order.operation_flag" class="operations">
        <div
          class="input-box input-box--radio"
          v-for="operation in operations"
          :key="operation.id"
        >
          <input
            type="radio"
            name="operation_id"
            :id="'operation' + operation.id"
            v-model="order.operation_id"
            :value="operation.id"
          />
          <label :for="'operation' + operation.id">
            {{ operation.name }}
          </label>
          <a
            href="#"
            class="input-box__info"
            @click.prevent="openOperationsModal(operation.id)"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="512px"
              height="512px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M256,0C114.51,0,0,114.5,0,256c0,141.49,114.5,256,256,256c141.49,0,256-114.5,256-256C512,114.51,397.5,0,256,0z M282.29,357.62c0,8.09-11.79,16.17-26.28,16.17c-15.16,0-25.95-8.09-25.95-16.17V229.23c0-9.43,10.78-15.84,25.95-15.84 c14.49,0,26.28,6.4,26.28,15.84V357.62z M256.01,182.4c-15.5,0-27.63-11.46-27.63-24.26c0-12.8,12.13-23.93,27.63-23.93 c15.16,0,27.3,11.12,27.3,23.93C283.3,170.94,271.17,182.4,256.01,182.4z"
                />
              </g>
            </svg>
          </a>
        </div>
      </div> -->
      <div
        class="input-box input-box--textarea"
        v-if="order.other_requirements_flag"
      >
        <textarea
          name="other_requirements"
          id="other_requirements"
          cols="30"
          rows="10"
          placeholder="Escribe tu requerimiento..."
          v-model="order.other_requirements"
        ></textarea>
      </div>
      <div
        v-if="
          order.operation_flag || order.glp_conversion || order.gnv_conversion
        "
        class="service-price"
      >
        <div class="service-price__column">
          <div class="service-price__number">
            <div class="service-price__title">Precio (inc. igv):</div>
            <div class="service-price__value">
              <span>S/ </span>
              <span>{{ order.total || '-' }}</span>
            </div>
          </div>
          <div class="service-price__message">
            <p>
              Aquí se muestra el precio regular del servicio de mantenimiento de
              su vehículo en el taller elegido, así como el de otros servicios
              disponibles.
            </p>
            <p>
              Puede continuar en el siguiente paso con el agendamiento de una
              cita con el taller.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="next-step">
      <a href="#" class="btn btn--outline" @click.prevent="prevStep()">
        Regresar
      </a>
      <a href="#" class="btn btn--blue" @click.prevent="nextStep()">
        Agendar cita
      </a>
    </div>
  </div>

  <second-step-services-modal
    :data="popup"
    @close-modal="closeModal()"
  ></second-step-services-modal>
</template>

<script>
import axios from 'axios'
import { computed, inject, onMounted, ref, watch, watchEffect } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'

export default {
  props: {
    url_get_operations_by_brand: {
      type: String,
      default: '',
    },
    url_get_operations_by_id: {
      type: String,
      default: '',
    },
    url_assets: {
      type: String,
      default: '',
    },
    urls: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const order = inject('order')
    const garages = inject('garages')
    const operations = ref([])
    const vehicles = inject('vehicles')
    const flag = inject('flag')
    const loading = inject('loading')
    const isMaintenance = ref(false)
    const isGLP = ref(false)
    const isGNV = ref(false)
    const isCYP = ref(false)
    const popup = ref({})
    const fuelTypes = ref([])
    const partTypes = ref([])
    const planTypes = ref([])
    const serviceTypes = ref([])
    const generations = ref([])
    const operationFilter = ref({
      brand_id: '',
      fuel_type: '',
      part_type: '',
      plan_type: '',
      service_type: '',
    })
    const gasOperationsFilter = ref({
      vehicle_version_id: '',
      fuel_type: '',
      part_type: '',
      service_type: '',
      gas_generation: '',
    })

    onMounted(() => {
      //   order.vehicle_id = ''
      if (order.garage_specialties.length > 0) {
        isMaintenance.value = order.garage_specialties.some(
          (element) => element.content === 'Mantenimiento Periódico'
        )
        isGLP.value = order.garage_specialties.some(
          (element) => element.content === 'Conversiones a GLP'
        )
        isGNV.value = order.garage_specialties.some(
          (element) => element.content === 'Conversiones a GNV'
        )
        isCYP.value = order.garage_specialties.some(
          (element) => element.content === 'Carrocería y Pintura'
        )
      }

      const queryPrams = new URLSearchParams(window.location.search)
      const otherRequirement = queryPrams.get('otrosRequerimientos')

      if (otherRequirement !== null) {
        order.other_requirements = otherRequirement
        order.other_requirements_flag = true
      }
    })

    watchEffect(() => {
      const garage = garages.find((element) => element.id == order.garage_id)

      if (garage) {
        order.garage_name = garage.name
      }
    })

    watchEffect(() => {
      if (order.operation_flag === false) {
        order.operation_name = ''
      }

      if (
        order.operation_flag === false &&
        order.glp_conversion === false &&
        order.gnv_conversion === false &&
        order.request_response === false
      ) {
        order.operation_id = ''
      }

      if (order.other_requirements_flag === false) {
        order.other_requirements = ''
      }

      if (
        order.operation_flag &&
        (order.glp_conversion || order.gnv_conversion || order.body_work)
      ) {
        order.glp_conversion = false
        order.gnv_conversion = false
        order.body_work = false
        order.other_requirements_flag = false
        order.other_requirements = ''
      }
    })

    watchEffect(() => {
      const vehicle = vehicles.value.find(
        (element) => element.id === order.vehicle_id
      )

      if (vehicle) {
        order.brand_id = vehicle.brand_id
        order.vehicle_plate = vehicle.plate
        order.brand_name = vehicle.brand_name
        order.model_name = vehicle.model_name
        order.version_id = vehicle.version_id
        order.version_name = vehicle.version_name

        if (order.operation_flag) {
          operationFilter.value.brand_id = vehicle.brand_id
          operationFilter.value.fuel_type = vehicle.fuel_type
        }

        if (order.glp_conversion || order.gnv_conversion) {
          gasOperationsFilter.value.vehicle_version_id = vehicle.version_id

          if (order.glp_conversion && !isDiesel.value) {
            gasOperationsFilter.value.fuel_type = 'GLP'
          }

          if (order.gnv_conversion && !isDiesel.value) {
            gasOperationsFilter.value.fuel_type = 'GNV'
          }

          if (
            (order.glp_conversion || order.gnv_conversion) &&
            isDiesel.value
          ) {
            gasOperationsFilter.value.fuel_type = 'Dual Fuel'
          }
        }
      } else {
        operationFilter.value.brand_id = ''
        operationFilter.value.fuel_type = ''
        gasOperationsFilter.value.vehicle_version_id = ''
      }
    })

    watchEffect(() => {
      if (operationFilter.value.part_type === '') {
        order.operation_id = ''
        order.operation_name = ''
      }
    })

    watch(
      () => order.vehicle_id,
      (currentValue, oldValue) => {
        if (currentValue !== '') {
          order.operation_id = ''
          order.operation_name = ''
          // try {
          //   order.request_response = false
          //   order.scheduled_appointment = false
          //   const { data } = await axios.request({
          //     url: props.url_get_operations_by_brand,
          //     method: 'POST',
          //     data: {
          //       vehicle_id: currentValue,
          //     },
          //   })
          //   operations.value = data
          //   order.operation_id = ''
          //   order.operation_name = ''
          // } catch (error) {
          //   console.log(error)
          // }
        } else {
          operations.value = []
          order.operation_id = ''
          order.operation_name = ''
          order.operation_flag = false
        }
      }
    )

    watch(
      () => order.operation_flag,
      (currentValue) => {
        if (currentValue === true) {
          order.glp_conversion = false
          order.gnv_conversion = false
          order.body_work = false
        }
      }
    )

    watch(
      () => order.glp_conversion,
      (currentValue) => {
        if (currentValue === true) {
          order.operation_flag = false
          order.gnv_conversion = false
          order.body_work = false

          if (isDiesel.value) {
            gasOperationsFilter.value.fuel_type = 'Dual Fuel'
          } else {
            gasOperationsFilter.value.fuel_type = 'GLP'
          }
        }
      }
    )

    watch(
      () => order.gnv_conversion,
      (currentValue) => {
        if (currentValue === true) {
          order.operation_flag = false
          order.glp_conversion = false
          order.body_work = false

          if (isDiesel.value) {
            gasOperationsFilter.value.fuel_type = 'Dual Fuel'
          } else {
            gasOperationsFilter.value.fuel_type = 'GNV'
          }
        }
      }
    )

    watch(
      () => order.body_work,
      (currentValue) => {
        if (currentValue === true) {
          order.operation_flag = false
          order.glp_conversion = false
          order.gnv_conversion = false
        }
      }
    )

    watch(
      () => order.operation_id,
      (currentValue) => {
        const operation = operations.value.find(
          (element) => element.id === currentValue
        )

        if (operation) {
          order.operation_name = operation.name
        }
      }
    )

    // Watchers for operations filters
    watch(
      () => operationFilter.value.brand_id,
      (currentValue, oldValue) => {
        if (currentValue !== oldValue) {
          operationFilter.value.part_type = ''
          operationFilter.value.plan_type = ''
          operationFilter.value.service_type = ''

          getFuelTypes()
        }
      }
    )

    watch(
      () => operationFilter.value.fuel_type,
      (currentValue, oldValue) => {
        operationFilter.value.part_type = ''
        operationFilter.value.plan_type = ''
        operationFilter.value.service_type = ''

        getPartTypes()
      }
    )

    watch(
      () => operationFilter.value.part_type,
      (currentValue, oldValue) => {
        if (currentValue !== oldValue) {
          operationFilter.value.plan_type = ''
          operationFilter.value.service_type = ''

          getPlanTypes()
        }
      }
    )

    watch(
      () => operationFilter.value.plan_type,
      (currentValue, oldValue) => {
        if (currentValue !== oldValue) {
          operationFilter.value.service_type = ''

          getServiceTypes()
        }
      }
    )

    watch(
      () => operationFilter.value.service_type,
      (currentValue) => {
        if (currentValue !== '') {
          const currentService = serviceTypes.value.find(
            (element) => element.service_type === currentValue
          )

          order.operation_id = currentService.id
          order.operation_name = currentService.name
        } else {
          order.operation_id = ''
          order.operation_name = ''
        }
      }
    )

    // Watchers for gas operations filters
    watch(
      () => gasOperationsFilter.value.vehicle_version_id,
      (currentValue, oldValue) => {
        if (currentValue !== oldValue) {
          gasOperationsFilter.value.part_type = ''
          gasOperationsFilter.value.fuel_type = ''
          gasOperationsFilter.value.gas_generation = ''
          gasOperationsFilter.value.service_type = ''

          if (order.glp_conversion) {
            gasOperationsFilter.value.fuel_type = 'GLP'
          }

          if (order.gnv_conversion) {
            gasOperationsFilter.value.fuel_type = 'GNV'
          }

          if (
            (order.glp_conversion || order.gnv_conversion) &&
            isDiesel.value
          ) {
            gasOperationsFilter.value.fuel_type = 'Dual Fuel'
          }

          getPartTypes()
        }
      }
    )

    watch(
      () => [order.glp_conversion, order.gnv_conversion],
      (currentValue, oldValue) => {
        if (
          currentValue.includes(true) &&
          gasOperationsFilter.value.vehicle_version_id !== ''
        ) {
          gasOperationsFilter.value.part_type = ''
          gasOperationsFilter.value.fuel_type = ''
          gasOperationsFilter.value.gas_generation = ''
          gasOperationsFilter.value.service_type = ''

          getPartTypes()
        }
      }
    )

    watch(
      () => gasOperationsFilter.value.part_type,
      (currentValue, oldValue) => {
        gasOperationsFilter.value.fuel_type = ''
        gasOperationsFilter.value.gas_generation = ''
        gasOperationsFilter.value.service_type = ''

        if (order.glp_conversion) {
          gasOperationsFilter.value.fuel_type = 'GLP'
        }

        if (order.gnv_conversion) {
          gasOperationsFilter.value.fuel_type = 'GNV'
        }

        if ((order.glp_conversion || order.gnv_conversion) && isDiesel.value) {
          gasOperationsFilter.value.fuel_type = 'Dual Fuel'
        }

        if (order.glp_conversion || order.gnv_conversion) {
          gasOperationsFilter.value.part_type === 'Conversión' ||
          gasOperationsFilter.value.fuel_type === 'Dual Fuel'
            ? getServiceTypes()
            : getGenerations()
        }
      }
    )

    watch(
      () => gasOperationsFilter.value.fuel_type,
      (currentValue, oldValue) => {
        gasOperationsFilter.value.gas_generation = ''
        gasOperationsFilter.value.service_type = ''

        generations.value = []
        serviceTypes.value = []

        if (currentValue === '') {
          return false
        }

        gasOperationsFilter.value.part_type === 'Conversión' ||
        currentValue === 'Dual Fuel'
          ? getServiceTypes()
          : getGenerations()
      }
    )

    watch(
      () => gasOperationsFilter.value.gas_generation,
      (currentValue, oldValue) => {
        gasOperationsFilter.value.service_type = ''

        if (currentValue === '') {
          return false
        }

        getServiceTypes()
      }
    )

    watch(
      () => gasOperationsFilter.value.service_type,
      (currentValue) => {
        if (currentValue !== '') {
          const currentService = serviceTypes.value.find((element) => {
            if (gasOperationsFilter.value.part_type === 'Conversión') {
              return element.name === currentValue
            } else {
              return element.service_type === currentValue
            }
          })

          order.operation_id = currentService.id
          order.operation_name = currentService.name
        } else {
          order.operation_id = ''
          order.operation_name = ''
        }
      }
    )

    const isDiesel = computed(() => {
      return vehicles.value.some(
        (element) =>
          element.id === order.vehicle_id && element.fuel_type === 'Diesel'
      )
    })

    const putMessageInRequest = (value, message) => {
      order.glp_conversion = false
      order.gnv_conversion = false
      order.body_work = false
      order.operation_flag = false
      order.operation_id = ''

      order.other_requirements = message
      order.other_requirements_flag = value
      order.request_response = value
    }

    const prevStep = () => {
      flag.value = 1
    }

    const nextStep = () => {
      if (order.operation_id === '' && !order.other_requirements_flag) {
        const data = {
          type: 2,
          title: '¡Ups!',
          subtitle: 'Debe seleccionar un Servicio o Requerimiento',
        }

        customAlert(data)

        return false
      }

      if (order.other_requirements_flag && order.other_requirements === '') {
        const data = {
          type: 2,
          title: '¡Ups!',
          subtitle: 'Debe escribir un requerimiento',
        }

        customAlert(data)

        return false
      }

      if (order.vehicle_id === '') {
        const data = {
          type: 2,
          title: '¡Ups!',
          subtitle: 'Debe seleccionar un Vehículo',
        }

        customAlert(data)

        return false
      }

      flag.value = 3
    }

    const openOperationsModal = async (id) => {
      loading.value = true

      try {
        const { data } = await axios.request({
          url: props.url_get_operations_by_id,
          method: 'POST',
          data: {
            id,
          },
        })

        if (data.length === 0) {
          const data = {
            type: 2,
            title: '¡Ups!',
            subtitle: 'Debe seleccionar un Servicio',
          }

          customAlert(data)

          loading.value = false
          return false
        }

        popup.value = data

        openModal()
      } catch (error) {
        console.log(error)
      }

      loading.value = false
    }

    const getFuelTypes = async () => {
      try {
        const { data } = await axios.request({
          url: props.urls.getFuelTypes,
          method: 'GET',
        })

        fuelTypes.value = data
      } catch (error) {
        console.log(error)
      }
    }

    const getPartTypes = async () => {
      try {
        const { data } = await axios.request({
          url: props.urls.getPartTypes,
          method: 'GET',
          params: {
            brand_id: operationFilter.value.brand_id,
            is_glp: order.glp_conversion,
            is_gnv: order.gnv_conversion,
            fuel_type: operationFilter.value.fuel_type,
          },
        })

        partTypes.value = data
      } catch (error) {
        console.log(error)
      }
    }

    const getPlanTypes = async () => {
      try {
        const { data } = await axios.request({
          url: props.urls.getPlanTypes,
          method: 'GET',
          params: {
            brand_id: operationFilter.value.brand_id,
            fuel_type: operationFilter.value.fuel_type,
            part_type: operationFilter.value.part_type,
          },
        })

        planTypes.value = data
      } catch (error) {
        console.log(error)
      }
    }

    const getGenerations = async () => {
      try {
        const { data } = await axios.request({
          url: props.urls.getGenerations,
          method: 'GET',
          params: {
            fuel_type: gasOperationsFilter.value.fuel_type,
            part_type: gasOperationsFilter.value.part_type,
            vehicle_version_id: gasOperationsFilter.value.vehicle_version_id,
            garage_id: order.garage_id,
          },
        })

        generations.value = data
      } catch (error) {
        console.log(error)
      }
    }

    const getServiceTypes = async () => {
      try {
        const { data } = await axios.request({
          url: props.urls.getServiceTypes,
          method: 'GET',
          params: {
            brand_id: operationFilter.value.brand_id,
            fuel_type:
              operationFilter.value.fuel_type ||
              gasOperationsFilter.value.fuel_type,
            part_type:
              operationFilter.value.part_type ||
              gasOperationsFilter.value.part_type,
            plan_type: operationFilter.value.plan_type,
            gas_generation: gasOperationsFilter.value.gas_generation,
            vehicle_version_id: gasOperationsFilter.value.vehicle_version_id,
            garage_id: order.garage_id,
          },
        })

        data.map((element) => {
          element.service_type_format = accounting.formatNumber(
            element.service_type,
            0,
            ',',
            '.'
          )

          return element
        })

        serviceTypes.value = data
      } catch (error) {
        console.log(error)
      }
    }

    const openModal = () => {
      $('#subOperationsModal').modal('show')
    }

    const closeModal = () => {
      popup.value = {}
    }

    return {
      isMaintenance,
      isGLP,
      isGNV,
      isCYP,
      order,
      operations,
      popup,
      vehicles,
      fuelTypes,
      partTypes,
      planTypes,
      serviceTypes,
      generations,
      operationFilter,
      gasOperationsFilter,
      isDiesel,
      putMessageInRequest,
      prevStep,
      nextStep,
      openOperationsModal,
      openModal,
      closeModal,
      getPartTypes,
      getPlanTypes,
      getGenerations,
      getServiceTypes,
    }
  },
}
</script>
<style>
.first-step .operations {
  border: 1px solid #d3d3d3;
  border-radius: 10px;
  height: 200px;
  overflow: auto;
  padding: 1rem;
}
</style>
